// Module
var code = "<div fg-property-field-common=\"{ fieldname: true,  displayname: true, tooltip: false }\"></div> <div fg-property-field-value> <input type=\"file\" name=\"fieldValue\" ng-model=\"field.value\"/> </div> ";
// Exports
export default code;